import { cssVar } from "@chakra-ui/theme-tools";
import { spacing1x, spacing4x, spacing5x, spacing6x, spacing8x, spacing12x, spacing10x } from "@airhelp/design-tokens";
const $size = cssVar("spinner-size");
const baseStyle = {
    width: [$size.reference],
    height: [$size.reference],
    color: "primary.500",
    margin: "unset !important",
};
const variantContentMedium = {
    [$size.variable]: spacing12x,
    borderWidth: "6px",
};
const variantContentLarge = {
    [$size.variable]: "4rem",
    borderWidth: "7px",
};
const sizes = {
    xs: {
        [$size.variable]: spacing4x,
    },
    sm: {
        [$size.variable]: spacing5x,
    },
    md: {
        [$size.variable]: spacing6x,
        borderWidth: "3px",
    },
    lg: {
        [$size.variable]: spacing8x,
        borderWidth: "3px",
    },
    xl: {
        [$size.variable]: spacing10x,
        borderWidth: spacing1x,
    },
};
const defaultProps = {
    size: "md",
};
const variants = {
    contentLarge: variantContentLarge,
    contentMedium: variantContentMedium,
};
const Spinner = {
    baseStyle,
    sizes,
    variants,
    defaultProps,
};
export default Spinner;
